import { AuthLayout } from "../layouts"
import { Grid, Button, Box, Text } from "@chakra-ui/react"
import { Input } from "../composites"
import { Formik, Form, Field, FormikHelpers } from "formik"
import * as Yup from "yup"
import { onLogin, setToken, setUser } from "../../services/login.service"
import { useShowToastHook } from "../../hooks/show-toast-hook"
import { useNavigate } from "react-router-dom"
import IsLoggedIn from "../hoc/is-logged-in"
import { useQuery, useQueryClient } from "react-query";

const LoginPage = () => {
  return (
    <IsLoggedIn>
      <AuthLayout
        title=" Welcome back!"
        desc="Please sign-in to your account and start the adventure"
      >
        <LoginForm />
      </AuthLayout>
    </IsLoggedIn>
  );
};

export default LoginPage;

const SignupSchema = Yup.object().shape({
  password: Yup.string()
    .min(2, "Password is too Short!")
    .max(50, "Password is too Long!")
    .required("Password is required!"),
  email: Yup.number().required("Login is required!"),
});

const LoginForm = () => {
  const { showSuccess, showError } = useShowToastHook();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleLogin = async (values: any, actions: FormikHelpers<any>) => {
    actions.setSubmitting(true);

    try {
      const result = await onLogin(values?.email, values?.password);

      if (result?.data?.status) {
        showSuccess("Login Successfull");
        // setUser(values?.email + "__USER__" + values?.password);
        setToken(result?.data?.data);
        queryClient.removeQueries();
        queryClient.clear();
        navigate("/");
        return;
      }
    } catch (error) {}

    showError("Incorrect credentials");
    actions.setSubmitting(false);
  };

  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
      }}
      validationSchema={SignupSchema}
      onSubmit={(values, actions: any) => {
        handleLogin(values, actions);
      }}
    >
      {({ errors, touched, isSubmitting }) => (
        <Form>
          <Grid gap={6}>
            <Field name="email">
              {({ field, form, meta }: any) => (
                <Input
                  title="Login"
                  {...field}
                  placeholder="Enter Login"
                  errorMessage={meta.touched && meta.error ? meta.error : ""}
                />
              )}
            </Field>

            <Field name="password">
              {({ field, form, meta }: any) => (
                <Box>
                  <Input
                    type="password"
                    title="password"
                    {...field}
                    placeholder="Enter password"
                    errorMessage={meta.touched && meta.error ? meta.error : ""}
                  />
                </Box>
              )}
            </Field>

            <Button isLoading={isSubmitting} colorScheme="blue" type="submit">
              Login
            </Button>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};
